import facebook from "./facebookPixel";
import ga from "./analytics";

export const trackPage = (page) => {
  facebook.trackPage(page);
  ga.trackPage(page);
};

export const trackDownload = (platform, method) => {
  facebook.trackDownload(platform, method);
  ga.trackDownload(platform, method);
};

export const trackSocial = (network) => {
  facebook.trackSocial(network);
  ga.trackSocial(network);
};

export const trackGuide = (platform) => {
  facebook.trackGuide(platform);
  ga.trackGuide(platform);
};

export const trackInstallFlow = (platform, action, tab = null) => {
  facebook.trackInstallFlow(platform, action, tab);
  ga.trackInstallFlow(platform, action, tab);
};
